/*
 * Text another part of the panel hands to a session: Autopilot's install
 * command and the terminal's CA command («Набрать в консоли»). Never sent with Enter:
 * the person reads it and runs it. In memory only — a command can hold a
 * one-time token, which belongs neither in the address bar nor in storage.
 */
const forServer = new Map<string, string>();
const forTab = new Map<string, string>();

/** Asks the next terminal of this server to paste `command` at its prompt once ready. */
export function typeInTerminal(serverId: string, command: string): void {
  forServer.set(serverId, command);
}

/** The command waiting for this server's next terminal, taken once. */
export function takeTerminalText(serverId: string): string | null {
  const text = forServer.get(serverId) ?? null;
  forServer.delete(serverId);
  return text;
}

/**
 * Offers `text` to an open console or remote desktop tab: its workspace
 * opens «Набрать текст» with it once the session is connected and on screen.
 */
export function offerText(tabId: string, text: string): void {
  forTab.set(tabId, text);
}

/** The text offered to this tab, if any (read without taking it). */
export function offeredText(tabId: string): string | null {
  return forTab.get(tabId) ?? null;
}

/** The dialog showed it: forget it, so it is offered once. */
export function clearOfferedText(tabId: string): void {
  forTab.delete(tabId);
}

/** A pasted command never ends with a line break: that would press Enter for the person. */
export const withoutEnter = (text: string): string => text.replace(/[\r\n]+$/, "");
